module.exports = __webpack_public_path__ + "img/Union.5f95f62.svg";